import moment from 'moment';

// TODO (ohtsuchi) 2025年以降 コードを削除 (ファイルごと全て削除)
export function expiredConfSortBy(): boolean {
  const envDate: string = process.env.VUE_APP_CONF_SORT_BY_EXPIRED_DATE || '';
  console.log('confSortByExpiredDate', envDate);
  if (envDate === '') {
    return false;
  }
  const expiredDate = moment(envDate, 'YYYY-MM-DD');
  return moment().isAfter(expiredDate);
}
